"use client";

import { CookieName } from "@/app/_utilities/cookieKeys";
import { logger } from "@utilities/logger";
import { UserCookieModel } from "@/app/_utilities/cookieModel";
import { getCookieValue } from "@/app/_utilities/cookies";
import { useEffect, useState } from "react";

type UserContextType = {
  isLoggedIn: boolean;
  userData: UserCookieModel | null;
};

export const getUserData = (): UserCookieModel | null => {
  const userCookie = getCookieValue(CookieName.User);
  if (userCookie) {
    try {
      const parsedUserData: UserCookieModel = UserCookieModel.fromJSON(userCookie);
      return parsedUserData;
    } catch (error) {
      logger.error(error instanceof Error ? error : null, "Failed to parse user cookie");
      return null;
    }
  }
  return null;
};

export const useUser = (): UserContextType => {
  const [loggedInState, setLoggedInState] = useState<UserContextType>({
    isLoggedIn: false,
    userData: null,
  });

  useEffect(() => {
    const userData = getUserData();
    setLoggedInState({
      isLoggedIn: userData !== null,
      userData,
    });
  }, []);

  return loggedInState;
};
